<template>
  <section class="not-found">
    <div class="text-center max-md:hidden">
      <div>
        {{
          $t("professionTaskList.notFound1", {
            professionName: professionNameUncapitalized || "",
          }) +
          (city && city.name
            ? $t("professionTaskList.notFound2")
            : $t("professionTaskList.notFound3")) +
          $t("professionTaskList.notFound4")
        }}<!--

         --><NuxtLink :to="personListUrl">{{
          $t("professionTaskList.notFound5", {
            professionName: professionNameUncapitalized || "",
          })
        }}</NuxtLink
        ><!--

         -->{{
          (city && city.name
            ? $t("professionTaskList.notFound6", {
                cityName: cityNameUncapitalized,
              })
            : $t("professionTaskList.notFound7")) +
          $t("professionTaskList.notFound8")
        }}
      </div>
      <JoszakiButton
        v-if="profession && profession.seoName"
        :to="personListUrl"
        type="info"
        expanded
        class="mt-4 lg:hidden"
      >
        &#60;&#60;&#60;
        {{
          $t("personList.cantFindBackButtonText", {
            profesionName: profession.name,
          })
        }}
      </JoszakiButton>
    </div>

    <BackToPersonList
      v-if="profession"
      class="back-to-person-list md:hidden"
      :text="`${
        city && city.name
          ? $t('professionTaskList.notFoundMobile1')
          : $t('professionTaskList.notFoundMobile2')
      }${$t('professionTaskList.notFoundMobile3')}`"
      :profession-name="profession.name"
      :back-url="personListUrl"
    />
  </section>
</template>

<script>
import BackToPersonList from "@/components/people/BackToPersonList.vue";

export default {
  components: {
    BackToPersonList,
  },
  props: {
    profession: {
      type: Object,
      required: false,
      default() {
        return null;
      },
    },
    city: {
      validator: (prop) => typeof prop === "string" || prop === null,
      required: true,
      default() {
        return {};
      },
    },
  },
  computed: {
    professionNameUncapitalized() {
      return this.profession?.name;
    },
    cityNameUncapitalized() {
      return this.city?.name?.toLowerCase();
    },
    personListUrl() {
      if (this.city && this.profession) {
        return this.localePath({
          name: "professionals",
          params: {
            profession: this.profession?.seoName,
            city: this.city?.seoName,
          },
        });
      }

      if (this.profession) {
        return this.localePath({
          name: "professionPage",
          params: {
            profession: this.profession?.seoName,
          },
        });
      }

      return this.localePath({
        name: "professionsLandingPage",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
}

.back-to-person-list {
  margin-bottom: 0.75rem;
}
</style>
